export default __webpack_public_path__ + "static/media/cookie6part1.51b92f93.svg";